import { instance } from '@/libs/api/instance.js'

/**
 * @param { string } id - Card uuid
 * @param { number } validate - validate flag
 * @param { Object } data - limits data object to update
 *
 * @returns {Promise<AxiosResponse<any>>}
 */

export const setLimits = (id, data, validate = 0) => {
  return instance.patch(`/v2/card/${id}/limits`, data, {
    params: { validate: Number(validate) },
  })
}
